import React from 'react';

const Page = React.lazy(() => import('./DepositReportPage'));

const DepositReportConfig = {
	settings: { layout: { config: {} } },
	routes: [
		{
			path: '/billing/reports/deposits',
			element: (
				<React.Suspense fallback={<>...</>}>
					<Page />
				</React.Suspense>
			),
		},
	],
	auth: ['school_admin', 'super_school_admin', 'sub_admin'],
};

export default DepositReportConfig;
